import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { eSystemModule, eUserPermissionLevel } from '@hub/generated/enums';
import { CurrentUserService } from '@hub/services/CurrentUserService';
import { take } from 'rxjs/operators';

@Component({
	selector: 'app-redirect',
	template: `
<div class="bg-contain m-3 p-2" *ngIf="message"><h3>{{message}}</h3></div>
`
})
export class MainRedirectComponent implements OnInit{
    constructor(private currentUserService: CurrentUserService, private router: Router) {
    }

	message: string;

	ngOnInit(): void {
    	let userRoleSystemModules;

		this.currentUserService.UserSystemModules
			.pipe(take(1)).subscribe(modules => {
				userRoleSystemModules = modules;
		})

		if (userRoleSystemModules.some(m => m.SystemModuleId === eSystemModule.HUBTvPackages_TvPackages && m.UserPermissionLevelFlag >= eUserPermissionLevel.Read)) {
			this.router.navigate(['/packages'], { replaceUrl: true });
		} else if (userRoleSystemModules.some(m => m.SystemModuleId === eSystemModule.HUBTv10Percent_Tv10Percent && m.UserPermissionLevelFlag >= eUserPermissionLevel.Read)) {
			this.router.navigate(['/tv10bookings'], { replaceUrl: true });
		} else {
			this.message = "You do not have the appropriate permissions to access WME.HUB";
		}
    }
}
